import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import useRoute from "./useRoute";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
// import loaderImg from "../assets/images/loader.gif";
import Auth from "../Navigation/Auth";
import Login from "../Views/Login";
import Layout from "../Views/Components/Layout";
import Dashboard from "../Views/Dashboard/Dashboard";
import ChangeInformation from "../Views/ChangeInformation";
import ChangePassword from "../Views/ChangePassword";
import Missing from "../Views/Missing";
import Weather from "../Views/Weather";
import HomeLayout from "../Views/Components/HomeLayout";
import Feedback from "../Views/Feedback";
import RejectionReason from "../Views/RejectionReason";
import Application from "../Views/SDRFManagement/Application";
import TrackingApplication from "../Views/trackingApplication";

const Routing = () => {
  const admin = useSelector((state) => JSON.parse(state.authentication.admin));
  const isLoggedIn = useSelector((state) => state.authentication.isAdmin);
  const permissions = isLoggedIn ? admin?.role?.permission : null;
  const { accessRouteHome, accessRoutes } = useRoute(permissions, admin?.role?.id);

  return (
    <>
      <ToastContainer />
      <Routes>
        <Route index element={<Login />} />
        <Route path="/feedback/:id" element={<Feedback />} />
        <Route path="/rejection-reason/:id" element={<RejectionReason/>} />
        <Route path="/login" element={<Navigate to="/" />} />
        <Route path="/track-application" element={<TrackingApplication />} />
        <Route element={<Auth redirectPath="/" />}>
          <Route path="/" element={<HomeLayout />}>
            {accessRouteHome}
          </Route>

          <Route path="/" element={<Layout />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="weather" element={<Weather />} />
            {accessRoutes}

            <Route path="change-information" element={<ChangeInformation />} />
            <Route path="change-password" element={<ChangePassword />} />
          </Route>
        </Route>
        <Route path="*" element={<Missing />} />
      </Routes>
    </>
  );
};

export default Routing;
